export const environment = {
    production: true
    ,name: "prod"
    ,api:{
        protocol:"https"
        //,host:"dtg-api.webscan-fleet.com"
        //,host:"localhost"
        //,port:443
        //,host:"221.139.14.167"
        ,host:"meta-api.whitebox.kr"
        ,port:443
    }
    ,websocket:{
        processor:{
            protocol:"https"
            //,host:"dtg-proc.webscan-fleet.com"
            //,port:443
            //,host:"localhost"
            //,host:"dtg-rest-api.prod"
            ,host:"meta-api.whitebox.kr"
            ,port:443
            ,websocketEndPoing:"fvms-dtg-processor-ws"
            ,server2client:"server2client"
            ,client2server:"client2server"
        }
    }
    ,google:{
        analytics:{
            id:"G-515V5ZZ7TK"
        }
        ,map:{
            key:"AIzaSyDoliAneRffQDyA7Ul9cDk3tLe7vaU4yP8"
        }
    }
};
